<template>
  <div ref='mychart' class="echart" style="width: 100%;height: 100%"></div>
</template>
  <script>
export default {
  props: {
    data: Object,
    mark: Number,
    unit: String,
    grid: Object
  },
  data() {
    return {

      timeList: [
        '2020-10-01',
        '2020-10-02',
        '2020-10-04',
        '2020-10-06',
        '2020-10-07',
      ],

      chartData: [
        {
          name: '上海顺鸣实业有限公司',
          dataList: [
            ['2020-10-01', 105300],
            ['2020-10-06', 105700],
          ],
        }
      ],
    }
  },
  mounted() {
    this.draw()
  },
  methods: {
    draw() {
      let colorList = [
        "#7299FF",
        "#FF9703",
        "#00FF14",
        "#00AAFF",
        "#FFBD00",
        "#FF0062",
        "#67DDA5",
        "#FF00E6",
        "#FFA872",
        "#2DAFC8",
        "#C8C62D",
        "#C8692D",
        "#BD2DC8",
        "#2DC86D",
        "#C82D6F",
        "#68FFC9",
        "#EB72FF",
      ]
      let mychart = this.$echarts.init(this.$refs.mychart)
      let defaultAxisColor = colorList[0]
      let axisLineColor = '#979797'
      let unit = this.unit ? '单位: ' + this.unit : ''
      let AxisData, data, legendName
      let series = []

      let grid = this.grid || {
        top: "23%",
        left: "5%",
        bottom: "5%",
        rigth: "5%",
        containLabel: true,
      }

      let mark = {}
      if (this.mark) {
        mark = {
          data: [{
            symbol: 'none',
            yAxis: this.mark
          }, {
            symbol: 'none',
            yAxis: this.mark
          }],
          lineStyle: {
            color: '#9ff'
          }
        }
      }

      if (this.data && this.data.datas.length) {
        let { datas, axis } = this.data
        console.log(this.data);
        AxisData = axis
        console.log(AxisData);
        data = []
        let legendName = []
        Object.keys(datas).map((key, i) => {
          console.log(i);
          let val = datas[key]
          let seriesData = []
          val.map(t => {
            let res = legendName.some(t => t.name = t.tsName)
            if (!res) legendName.push({
              name: t.tsName,
              itemStyle: { color: colorList[i] ? colorList[i] : colorList[0] }
            })
            let { tbiDocumentDate: date, tbiDocumentAmount: amount } = t
            seriesData.push([date, amount])
          })
          series.push({
            name: val[0].tsName,
            data: seriesData,
            markLine: mark,
            type: 'line',
            symbol: 'roundRect',
            symbolSize: 10,
            lineStyle: { color: colorList[i] ? colorList[i] : colorList[0] },
            itemStyle: {
              borderType: "solid",
              color: colorList[i] ? colorList[i] : colorList[0]
            },
            label: {
              show: true
            }
          })
        })
        console.log(series);

      } else {
        data = [820, 932, 901, 934, 1290, 1330, 1320]
        AxisData = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
      }

      let option = {
        title: {
          text: unit,
          right: 45,
          top: 30,
          textStyle: {
            color: '#448FFF',
            fontSize: 14,
          }
        },
        grid,
        tooltip: {
          trigger: 'axis',  // 指示器显示规则, axis为根据坐标, item为根据折线点具体位置
          axisPointer: {    // 指示器配置
            type: 'line',
            label: {
              show: true,
              backgroundColor: '#333',
              color: '#9ff'
            }
          }
        },
        legend: {
          data: legendName,
          right: '10%',
          top: '5%'

        },
        xAxis: {
          type: 'category',
          data: AxisData,
          axisLine: {   // 坐标轴的配置
            lineStyle: {
              width: 1,
              color: axisLineColor
            }
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          splitLine: {
            show: true,
            lineStyle: {
              color: defaultAxisColor
            }
          },   // 不显示图表中折线图分割线
          type: 'value',
          axisLine: {   // 坐标轴的配置
            lineStyle: {
              width: 1,
              color: axisLineColor
            }
          },
          axisTick: {
            show: false
          }
        },

        dataZoom: {
          type: 'inside'
        },
        series,
        // series: [{
        //   name: legendName,
        //   data: data,
        //   markLine: mark,
        //   type: 'line',
        //   symbol: 'emptyCircle',
        //   symbolSize: 10,
        //   lineStyle: { color: lineColor },
        //   itemStyle: {
        //     borderType: "solid",
        //     color: "rgba(0, 255, 55, 1)"
        //   },
        // }]
      };
      mychart.setOption(option)

    }
  }
}
  </script>
  
  <style scope lang='scss'>
.echart div:first-child {
  width: 100% !important;
  height: 100% !important;
}
.echart canvas {
  width: 100% !important;
  height: 100% !important;
}
</style>
  